import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SwiperConfigInterface, SwiperPaginationInterface } from 'ngx-swiper-wrapper';
import { ProductService } from 'src/app/components/shared/services/product.service';

@Component({
  selector: 'app-product-dailog-gif',
  templateUrl: './product-dailog-gif.component.html',
  styleUrls: ['./product-dailog-gif.component.sass']
})
export class ProductDailogGifComponent implements OnInit {
  public product;
  public selectedProductImageIndex;
  paramsCarouselMovil:any[]=[]
  public config: SwiperConfigInterface = {};
  private pagination: SwiperPaginationInterface = {
    el: ".swiper-pagination",
    clickable: true,
  };
  constructor(
    private productsService: ProductService,
    public dialogRef: MatDialogRef<ProductDailogGifComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { product }
  ) {
    this.product = data;
    // console.log(this.product)
  }

  ngOnInit(): void {
  }
  public close(): void {
    this.dialogRef.close();
  }
  ngAfterViewInit() {
    this.config = {
      observer: true,
      slidesPerView: 3,
      spaceBetween: 10,
      keyboard: true,
      navigation: true,
      pagination: false,
      grabCursor: true,
      loop: false,
      preloadImages: false,
      lazy: true,
      breakpoints: {
        480: {
          slidesPerView: 1,
        },
        740: {
          slidesPerView: 2,
        },
        960: {
          slidesPerView: 3,
        },
        1280: {
          slidesPerView: 3,
        },
      },
    };
  }
}
